import { IndicatorData } from '../TechnicalAnalysisTradingView';
import { OhlcRow } from './SMA';

// Element based on 60-day Ganzhi cycle (5 elements x 12 days = 60)



// Element to number mapping
const elementToNumber: Record<string, number> = {
  "Wood": 1,
  "Fire": 2,
  "Earth": 3,
  "Metal": 4,
  "Water": 5
};

// Element color mapping
const elementColors: Record<string, string> = {
  "Wood": "#16a34a",    // Green
  "Fire": "#ff4500",    // Fiery Orange-Red
  "Earth": "#6b4226",   // Deep Natural Soil Brown
  "Metal": "#94a3b8",   // Metallic Steel Silver
  "Water": "#38bdf8"    // Light Sky Blue
};

// Get element emoji
const getElementEmoji = (element: string): string => {
  const emojiMap: Record<string, string> = {
    "Wood": "🌳",
    "Fire": "🔥",
    "Earth": "⛰️",
    "Metal": "⚒️",
    "Water": "🌊"
  };
  return emojiMap[element] || "⭐";
};

import { getDayBaZiDetail } from './BaZiIndicator';

// Export function to get daily element info
export function getDailyElementInfo(date: Date, timeframe?: string): { element: string; color: string; emoji: string; yinyang: "Yin" | "Yang"; yyCode: "A" | "I" } {
  const bazi = getDayBaZiDetail(date, timeframe);
  const element = bazi.mainElement;
  return {
    element,
    color: elementColors[element] || "#6B7280",
    emoji: getElementEmoji(element),
    yinyang: bazi.mainYinYang,
    yyCode: bazi.mainYYCode,
  };
}

// Export element info for legend
export const ELEMENT_INFO = Object.keys(elementColors).map(element => ({
  name: element,
  emoji: getElementEmoji(element),
  color: elementColors[element]
}));

// Use BaZiCycleAnalysis method exactly (copied from BaZiCycleAnalysis.tsx line 273-281)
function dayPillarExact(localDate: Date, timeframe?: string){
  const bazi = getDayBaZiDetail(localDate, timeframe);
  return { 
    pillarCN: bazi.pillarCN, 
    stemCN: bazi.stemCN, 
    branchCN: bazi.branchCN, 
    element: bazi.mainElement, 
    yinyang: bazi.mainYinYang, 
    shio: bazi.shio 
  };
}

export function calculateDailyElement(data: OhlcRow[], timeframe?: string): { 
  data: IndicatorData[]; 
  labels: string[];
  colors: string[];
} {
  const result: IndicatorData[] = [];
  const labels: string[] = [];
  const colors: string[] = [];
  
  let lastDate = '';
  
  for (const row of data) {
    const date = new Date(row.time * 1000);
    
    // Get date string in YYYY-MM-DD format to check if it's a new day
    const dateStr = date.toISOString().split('T')[0] || '';
    const isNewDay = dateStr !== lastDate;
    
    if (isNewDay) {
      const pillarData = dayPillarExact(date, timeframe);
      const element = pillarData.element;
      const elementNum = elementToNumber[element] || 0;
      
      result.push({
        time: row.time,
        value: elementNum
      });
      
      labels.push(element);
      colors.push(elementColors[element] || "#6B7280");
      
      lastDate = dateStr;
    } else {
      // For same day, use the last calculated value
      result.push({
        time: row.time,
        value: result[result.length - 1]?.value || 1
      });
      
      labels.push(labels[labels.length - 1] || "Wood");
      colors.push(colors[colors.length - 1] || "#6B7280");
    }
  }
  
  return { data: result, labels, colors };
}
